import { useState } from "react";
import Select from "react-select";

function OfferEdes() {
  const [periodo, setPeriodo] = useState(null);
  const [modalidad, setModalidad] = useState(null);
  const [tipo, setTipo] = useState(null);
  const [campo, setCampo] = useState(null);

  const optionsoferta = [
    { value: "todos", label: "Toda la oferta" },
    { value: "octubre 2025 - febrero 2026", label: "Vigente" },
    { value: "abril - agosto 2026", label: "Próxima" },
  ];

  const optionsmodalidad = [
    { value: "todos", label: "Todas las modalidades" },
    { value: "en línea", label: "En línea" },
    { value: "presencial", label: "Presencial" },
    { value: "híbrida", label: "Híbrida" },
  ];

  const optionstipo = [
    { value: "todos", label: "Todas los programas" },
    { value: "Maestría", label: "Maestría" },
    { value: "Especialización", label: "Especialización" },
    { value: "Especialización médica", label: "Especialización médica" },
    { value: "Doctorado", label: "Doctorado" },
  ];

  const optionscampo = [
    { value: "todos", label: "Todos los programas" },
    { value: "Administración", label: "Administración" },
    {
      value: "Administración de Empresas y Derecho",
      label: "Administración de Empresas y Derecho",
    },
    {
      value: "Ciencias Naturales, Matemáticas y Estadística",
      label: "Ciencias Naturales, Matemáticas y Estadística",
    },
    {
      value: "Ciencias Sociales, Periodismo, Información y Derecho",
      label: "Ciencias Sociales, Periodismo, Información y Derecho",
    },

    {
      value: "Educación",
      label: "Educación",
    },
    {
      value: "Educación Comercial y Administración",
      label: "Educación Comercial y Administración",
    },

    {
      value: "Ingeniería, Industria y Construcción",
      label: "Ingeniería, Industria y Construcción",
    },
    {
      value: "Servicios",
      label: "Servicios",
    },
    {
      value: "Salud y Bienestar",
      label: "Salud y Bienestar",
    },
    {
      value: "Tecnologías de la Información y la Comunicación (TIC)",
      label: "Tecnologías de la Información y la Comunicación (TIC)",
    },
  ];

  function IsTag(data) {
    if (data && data.trim && data.trim() !== "") {
      return <p className="tag-2">{data}</p>;
    }
    return null; // Renderiza nada si data está vacío
  }

  const programas = [

 {
      titulo: "Gestión del Talento Humano con Mención en Management 3.0",
      modalidad: "en línea",
      duracion: "1 año",
      facultad: "Edes Escuela de Negocios",
      campo: "Administración",
      tipo: "Maestría",
      imagen:
        "https://www.utpl.edu.ec/maestrias/sites/default/files/talento-humano-edes.png",
      url: "https://edes.utpl.edu.ec/oferta-academica/maestrias/gestion-del-talento-humano",
   
      inicio: "Abril 2026",
    },

    {
      titulo: "Gestión Empresarial",
      modalidad: "en línea",
      duracion: "1 año",
      facultad: "Edes Escuela de Negocios",
      campo: "Administración",
      tipo: "Maestría",
      imagen:
        "https://www.utpl.edu.ec/maestrias/sites/default/files/gestion-empresarial-edes.png",
      url: "https://edes.utpl.edu.ec/oferta-academica/maestrias/gestion-empresarial",
    inicio: "Abril 2026",
    },

   
    {
      titulo: "Marketing mención en Transformación Digital",
      modalidad: "en línea",
      duracion: "1 año",
      facultad: "EDES Escuela de negocios",
      campo: "Administración de Empresas y Derecho",
      tipo: "Maestría",
      imagen:
        "https://www.utpl.edu.ec/maestrias/sites/default/files/marketing-edes.png",
      url: "https://edes.utpl.edu.ec/oferta-academica/maestrias/marketing-con-mencion-en-transformacion-digital",
        inicio: "Abril 2026",
    },

   
 /*    {
      titulo: "MBA con mención en Innovación - presencial",
      modalidad: "presencial",
      duracion: "1 año",
      facultad: "EDES Escuela de negocios",
      campo: "Administración",
      tipo: "Maestría",
      imagen:
        "https://www.utpl.edu.ec/maestrias/sites/default/files/mba-presencial-edes.png",
      url: "https://edes.utpl.edu.ec/oferta-academica/maestrias/mba-presencial",
      periodo: "octubre 2025 - febrero 2026",
      inicio: "octubre 2025",
    }, */
    {
      titulo: "MBA con mención en Innovación - en línea",
      modalidad: "en línea",
      duracion: "1 año",
      facultad: "EDES Escuela de negocios",
      campo: "Administración",
      tipo: "Maestría",
      imagen:
        "https://www.utpl.edu.ec/maestrias/sites/default/files/mba-enlinea-edes.png",
      url: "https://edes.utpl.edu.ec/oferta-academica/maestrias/mba-a-distancia",
     inicio: "Abril 2026",
    },
        {
      titulo: "Dirección Financiera con mención en Fintech",
      modalidad: "en línea",
      duracion: "1 año",
      facultad: "EDES Escuela de Negocios",
      campo: "Administración de Empresas y Derecho",
      tipo: "Maestría",
      imagen:
        "https://www.utpl.edu.ec/maestrias/sites/default/files/direccion-financiera-edes.png",
      url: "https://edes.utpl.edu.ec/oferta-academica/maestrias/direccion-financiera-con-mencion-en-fintech",
    
      inicio: "octubre 2026",
    },
     {
      titulo: "MBA con mención en Transformación Digital",
      modalidad: "en línea",
      duracion: "1 año",
      facultad: "EDES Escuela de negocios",
      campo: "Administración",
      tipo: "Maestría",
      imagen:
        "https://www.utpl.edu.ec/maestrias/sites/default/files/mba-transformacion-digital-edes.png",
      url: "https://edes.utpl.edu.ec/maestria-transformacion-digital",
   
      inicio: "octubre 2026",
    },

    // Agrega los demás programas aquí con la misma estructura...
  ];
  const handleChangePeriodo = (selected) => {
    setPeriodo(selected);
  };
  const handleChangeModalidad = (selected) => {
    setModalidad(selected);
  };
  const handleChangeTipo = (selected) => {
    setTipo(selected);
  };
  const handleChangeCampo = (selected) => {
    setCampo(selected);
  };

  const programasFiltrados = programas.filter((p) => {
    const coincidePeriodo =
      !periodo ||
      periodo.value === "todos" ||
      p.periodo.toLowerCase() === periodo.value.toLowerCase();

    const coincideModalidad =
      !modalidad ||
      modalidad.value === "todos" ||
      p.modalidad.toLowerCase() === modalidad.value.toLowerCase();

    const coincideTipo =
      !tipo ||
      tipo.value === "todos" ||
      p.tipo.toLowerCase() === tipo.value.toLowerCase();

    const coincideCampo =
      !campo ||
      campo.value === "todos" ||
      p.campo.toLowerCase() === campo.value.toLowerCase();

    return (
      coincidePeriodo && coincideModalidad && coincideTipo && coincideCampo
    );
  });

  return (
    <div>
      <div className="bloque2 margin">
        <div className="wrapper-academicoffer">
          {programasFiltrados.map((programa, index) => (
            <div key={index}>
              {programa.imagen && (
                <div className="programa-imagen">
                  <img src={programa.imagen} alt={programa.titulo} />
                </div>
              )}
              <div className="layout8">
                <div className="flex-start">
                  <p className="tipoposgrado"> {programa.tipo}</p>
                </div>

                <h3>{programa.titulo}</h3>
                <p>
                  <b>Modalidad: </b>
                  {programa.modalidad}
                </p>
                <p>
                  <b>Duración:</b> {programa.duracion}
                </p>
                <p>
                  <b>Campo del conocimiento: </b>
                  {programa.campo}
                </p>
               
                {programa.periodo && (
                  <p>
                    <b>Periodo: </b>
                    {programa.periodo}
                  </p>
                )}
                {programa.inicio && (
                  <p>
                    <b>Inicio de clases: </b>
                    {programa.inicio}
                  </p>
                )}
                <div className="wrapper-link">
                  <a
                    className="link-offer"
                    href={programa.url}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Ver programa
                    <span className="material-icons">arrow_forward_ios</span>
                  </a>
                </div>
              </div>
            </div>
          ))}
          {programasFiltrados.length === 0 && (
            <p>No hay programas disponibles.</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default OfferEdes;
